import React from "react";
import Css from "./HtmlCss.module.css";
import { Link } from "react-router-dom";
import NativeImage from "../PackageImage/NativeImage";
const HtmlCss = () => {
  const products = [
    {
      id: 1,
      title: "Website Pharahos",
      FrameWork: "HTML & CSS",
      paragraph:
        "Our goal is to encourage more people around the world to visitEgypt by showing them the ancient parts in the form of photos",
      span: "Not Responsive",
      Preview: "https://mohamed-adel0.github.io/Pharaohs/",
      GitHub: "https://github.com/Mohamed-Adel0/Pharaohs",
      image: NativeImage.Pharahos,
    },
    {
      id: 2,
      title: "Website JFC",
      FrameWork: "HTML & CSS",
      paragraph:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolores dignissimos est dolor beatae qui cupiditate.",
      span: "Responsive 70%",
      Preview: "https://mohamed-adel0.github.io/JFC/",
      GitHub: "https://github.com/Mohamed-Adel0/JFC",
      image: NativeImage.JFC,
    },
  ];
  return (
    <div>
      <div className={Css.container}>
        {products?.map((r) => (
          <div className={Css.cards} key={r.id}>
            <div className={Css.card}>
              <div className={Css.img}>
                <Link to={r.Preview} target="_blank">
                  <img src={r.image} alt="" />
                </Link>
              </div>
              <div className={Css.text}>
                <h2>
                  {r.title} <span>{r.FrameWork}</span>
                </h2>
                <p>
                  {r.paragraph} <span>{r.span}</span>
                </p>
                <div className={Css.src}>
                  <Link target="_blank" to={r.Preview}>
                    Preview
                  </Link>
                  <Link target="_blank" to={r.GitHub}>
                    GitHub
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HtmlCss;
